<template lang="pug">
.content-wrapper
  StepsCard()
    template(#steps)
      router-link(:to="{name: 'cco-referrals.scheduling.search-patient'}", v-slot="{ href, route, navigate, isActive, isExactActive }", custom)
        li(
          :class="[isActive && 'router-link-exact-active']"
        ) <span>Search Patient</span>
          base-icon(name="arrow-steps")

      router-link(:to="{name: 'cco-referrals.scheduling.select-patient'}", v-slot="{ href, route, navigate, isActive, isExactActive }", custom)
        li(
          :class="[isActive && 'router-link-exact-active']"
        ) <span>Select Patient</span>
          base-icon(name="arrow-steps")

      router-link(:to="{name: 'cco-referrals.scheduling.select-provider'}", v-slot="{ href, route, navigate, isActive, isExactActive }", custom)
        li(
          :class="[isActive && 'router-link-exact-active']"
        ) <span>Select Provider</span>
          base-icon(name="arrow-steps")

      router-link(:to="{name: 'cco-referrals.scheduling.referral-info'}", v-slot="{ href, route, navigate, isActive, isExactActive }", custom)
        li(
          :class="[isActive && 'router-link-exact-active']"
        ) <span>Referral Info</span>
          base-icon(name="arrow-steps")

      router-link(:to="{name: 'cco-referrals.scheduling.confirm'}", v-slot="{ href, route, navigate, isActive, isExactActive }", custom)
        li(
          :class="[isActive && 'router-link-exact-active']"
        ) <span>Confirm</span>

    template(#content)
      router-view()
</template>

<script>
import { defineComponent } from "vue";
import StepsCard from "@/components/StepsCard.vue";

export default defineComponent({
  components: { StepsCard },

  data() {
    return {};
  },

  methods: {},
});
</script>

<style scoped lang="scss">
.content-wrapper {
  position: relative;
  padding-bottom: 40px;
}
</style>
